<h2>Betalningsbektäftelse på order {{orderId}}</h2>
@if (klarnaSnippet) {
  <div [innerHTML]="klarnaSnippet | keepHtml" runScripts>
  </div>
}

@if (order) {
  <div>
    @for (orderItem of order.orderItems; track orderItem) {
      <div class="order-item">
        @if (orderItem.orderItemType === 'RESOURCE' && orderItem.booking) {
          <div>
            <div>BookingId: {{orderItem.booking.bookingId}}</div>
            <div>Registreringsnummer: {{orderItem.booking.registrationNumber}}</div>
            <div>Datum: {{orderItem.booking.departureDate | date }} - {{orderItem.booking.arrivalDate | date }}</div>
            <div>
              QR: {{orderItem.booking.qr}}
              <img [src]="'data:image/png;base64,' + orderItem.booking.qrImage">
            </div>
          </div>
        }
        @if (orderItem.orderItemType === 'FEATURE' && orderItem.feature) {
          <div>
            <div>FeatureId: {{orderItem.feature.featureId}}</div>
            <div>
              Name: {{orderItem.feature.name}}
            </div>
          </div>
        }
      </div>
    }
  </div>
}